var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHeartBlueFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.167,
    height: 24.523,
    viewBox: "0 0 26.167 24.523",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M14.083,25.173l-1.752-1.595C6.108,17.935,2,14.213,2,9.646A6.581,6.581,0,0,1,8.646,3a7.236,7.236,0,0,1,5.437,2.525A7.236,7.236,0,0,1,19.521,3a6.581,6.581,0,0,1,6.646,6.646c0,4.568-4.108,8.289-10.331,13.944Z",
    transform: "translate(-1 -2)",
    fill: "#1e97ff",
    stroke: "#1e97ff",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeartBlueFilled);
export default __webpack_public_path__ + "static/media/icon_heart_blue_filled.30b5c3bf76b1a4a4d1c7f173b9689902.svg";
export { ForwardRef as ReactComponent };